import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import ErrorBoundary from "components/Library/ErrorBoundary";
import { MicrodataContext } from "config/contexts";

import styles from "./CardWrapper.css";

export default function CardWrapper(props) {
  const WrapperTag = props.wrapperTag;

  return (
    <ErrorBoundary>
      <MicrodataContext.Consumer>
        {microdata => (
          <WrapperTag
            className={classNames(styles.root, props.className)}
            role={props.ariaRole}
            aria-label={props.ariaLabel}
            itemScope={microdata}
            itemType={microdata ? "http://schema.org/NewsArticle" : undefined}
            data-content-id={props.contentId}
          >
            {props.children}
          </WrapperTag>
        )}
      </MicrodataContext.Consumer>
    </ErrorBoundary>
  );
}

CardWrapper.defaultProps = {
  wrapperTag: "div",
};

CardWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  ariaRole: PropTypes.string,
  ariaLabel: PropTypes.string,
  contentId: PropTypes.string,
  wrapperTag: PropTypes.string,
};
